import React, { Component } from "react";
import { Table, Button, Alert } from "antd";
import TableColumnWithTooltip from "../shared/TableColumnWithTooltip/TableColumnWithTooltip";
import { semTableColumns } from "../shared/TableColumnWithTooltip/semTableColumns";
import SparklineChart from "../shared/SparklineChart/SparklineChart";
import LoadingIndicator from "../shared/LoadingIndicator/LoadingIndicator";

const { Column } = Table;

const keywordResearchTableCell = value => {
  value = parseInt(value);
  return value ? value.toLocaleString() : <span className="not-available">n/a</span>;
};

class KeywordResearchTable extends Component {
  render() {
    const tableDataSource = this.props.keywords.map((keyword, idx) => ({
      key: idx + 1,
      keyword: keyword.phrase,
      searchVolume: keyword["vol"], // !== "0" ? parseInt(keyword["vol"]).toLocaleString() : "n/a",
      cpc: keyword["cpc"], // !== "0" ? parseFloat(keyword["cpc"]).toLocaleString() : "n/a",
      cmp: keyword["cmp"], // !== "0" ? parseFloat(keyword["cmp"]).toLocaleString() : "n/a",
      resultsNo: keyword["r_no"], // !== "0" ? parseInt(keyword["r_no"]).toLocaleString() : "n/a",
      trends: keyword["trends"]
    }));

    if (this.props.isFirstFetch) {
      return <LoadingIndicator />;
    }

    return this.props.keywords.length ? (
      <div className="keywords-table">
        <Table
          dataSource={tableDataSource}
          pagination={false}
          size="small"
          data-cy="keyword-research-table-inside-modal">
          <Column title="#" dataIndex="key" align="left" width="43" className="no-wrap" />
          <Column className="no-wrap" title="Keyword" dataIndex="keyword" />
          <Column
            className="al-left"
            title={<TableColumnWithTooltip {...semTableColumns["search_volume"]} />}
            dataIndex="searchVolume"
            render={(_, record) => keywordResearchTableCell(record.searchVolume)}
          />
          <Column
            className="al-left"
            title={<TableColumnWithTooltip {...semTableColumns["cpc"]} />}
            dataIndex="cpc"
            render={(_, record) => keywordResearchTableCell(record.cpc)}
          />
          <Column
            className="al-left"
            title={<TableColumnWithTooltip {...semTableColumns["cmp"]} />}
            dataIndex="cmp"
            render={(_, record) => keywordResearchTableCell(record.cmp)}
          />
          <Column
            className="al-left"
            title={<TableColumnWithTooltip {...semTableColumns["results_no"]} />}
            dataIndex="resultsNo"
            render={(_, record) => keywordResearchTableCell(record.resultsNo)}
          />
          <Column
            className="keyword-trends al-right"
            title={<TableColumnWithTooltip {...semTableColumns["trends"]} />}
            dataIndex="trends"
            render={(_, record) => {
              if (record["trends"]) {
                const trend = record["trends"].split(",").map(item => parseFloat(item));
                return <SparklineChart data={trend} />;
              }
              return "-";
            }}
          />
        </Table>
        {this.props.hasMore ? (
          <Button className="load-more" type="primary" loading={this.props.isLoading} onClick={this.props.onLoadMore}>
            Load more
          </Button>
        ) : null}
      </div>
    ) : (
      <Alert message="No keywords found for your search!" />
    );
  }
}

export default KeywordResearchTable;
